import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";
import { sortDramas } from "@/lib/data";
import DramaCard from "@/components/base/DramaCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { Drama } from "@/types";

const hot = sortDramas(dramas as Drama[], "popularity").slice(0, 8);

export default function HotDramas() {
  return (
    <section className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <SectionHeading
        title="热门剧集推荐"
        subtitle="近期讨论度最高的剧集，追剧不迷路"
        moreLink="/list/hot"
        moreText="更多热剧"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {hot.map((d, i) => (
          <DramaCard key={d.id} drama={d} rank={i + 1} />
        ))}
      </div>
      <div className="mt-8 text-center">
        <Link
          to="/list/hot"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-fire-line text-lg" />
          查看全部热播剧集
        </Link>
      </div>
    </section>
  );
}